module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/InfluencerExample/5_0-c9b2a9867a336ed1692d3cd36cda4c63.png";